import React from "react";
import "./ToastNotification.css";

export const ToastNotification = ({ data }) => {
    return (
        <div className="epac-toast-notification">
            {data.title && <div>{data.title}</div>}
            {data.content && <div>{data.content}</div>}
        </div>
    );
};
